import { useState } from 'react';
import { api } from '../api/client';
import { AppForm } from '../components/AppForm';
import { ErrorBanner } from '../components/ErrorBanner';
import { navigate } from '../router';

export function AppCreate() {
  const [error, setError] = useState<unknown>();
  const [busy, setBusy] = useState(false);

  return (
    <>
      <div className="pagehead">
        <h1>Register an app</h1>
      </div>

      <p className="muted">
        Creates a Cognito app client and its registry row. No deploy is needed, and the sign-in URL
        works immediately.
      </p>

      <ErrorBanner error={error} />

      <AppForm
        initial={{ appName: '', redirectUris: [], requiredGroupIds: [] }}
        nameEditable
        submitLabel="Register app"
        busy={busy}
        onSubmit={(values) => {
          setBusy(true);
          setError(undefined);
          api
            .create({
              appName: values.appName,
              redirectUris: values.redirectUris,
              requiredGroupIds: values.requiredGroupIds,
            })
            .then((app) => navigate(`/apps/${encodeURIComponent(app.app_name)}`))
            .catch(setError)
            .finally(() => setBusy(false));
        }}
      />
    </>
  );
}
